import {StaticImageData} from 'next/image'

export default class Plan {
  constructor(
    public price: number,
    public nbOfGenerations: number,
    public keyName: string,
    public icon: StaticImageData,
    public priceId?: string,
    public nbOfGenerations14firstDays?: number
  ) {}
}
